import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { faSearch, faGlobeEurope, faPencilAlt, faCheck, faTimes, faUsers, faInfoCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faAddressBook, faFileAlt, faThumbsUp, faEye, faEyeSlash, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AppointmentService } from '../shared/services/appointments.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Appointment } from '../shared/models/appointment.model';
import { Filter } from '../shared/models/filter.model';
import { AppointmentStatusService } from '../shared/services/admin-services/appointment-status.service';
import { Lookup } from '../shared/models/admin-models/lookup.model';
import { UserService } from '../shared/services/admin-services/user.service';
import { IncomeService } from '../shared/services/admin-services/income.service';
import { WorkStatusService } from '../shared/services/admin-services/work-status.service';
import { RecommendationService } from '../shared/services/recommendation.service';
import { Recommendation } from '../shared/models/recommendation.model';
import { StandardOSOffer } from '../shared/models/offer-models/standard-os-offer.model';
import { ClientStatusService } from '../shared/services/admin-services/client-status.service';
import { OfferClient } from '../shared/models/offer-models/offer-client.model';
import { OfferInsuree } from '../shared/models/offer-models/offer-insuree.model';
import { OfferService } from '../shared/services/offer-services/offer.service';
import { RoleSendService } from '../shared/services/role-send.service';
import { BranchOfficeService } from '../shared/services/admin-services/branch-office.service';
import { formatDate } from '@angular/common';
import { NLOfferService } from '../shared/services/nl-services/nl-offer.service';
import { NLOffer } from '../shared/models/nl-models/nl-offer.model';
import { NLCalculatorService } from '../shared/services/nl-services/nl-calculator.service';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.sass'],
  providers: [NLOfferService, NLCalculatorService]
})
export class AppointmentsComponent implements OnInit, OnDestroy {
  faCalendarAlt = faCalendarAlt;
  faSearch = faSearch;
  faAddressBook = faAddressBook;
  faGlobeEurope = faGlobeEurope;
  faPencilAlt = faPencilAlt;
  faFileAlt = faFileAlt;
  faThumbsUp = faThumbsUp;
  faCheck = faCheck;
  faTimes = faTimes;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faUsers = faUsers;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  faPlus = faPlus
  faMinus = faMinus

  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle;

  total: Number;
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })

  appointmentsArray;
  appointmentStatusArray: Observable<Lookup[]>;
  workStatusArray: Observable<Lookup[]>;
  incomeArray: Observable<Lookup[]>;

  userId: Number;
  appointmentId: Number;
  appointmentStatus: Boolean;

  addOrEditBool: Boolean = true;
  dateMinimum: { year: Number, month: Number, day: Number } = { year: 0, month: 0, day: 0 };
  dateToday = new Date();

  roleService: Subscription;
  roleType: String = '';

  appointmentsForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    homeNumber: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    dateOfAppointment: new FormControl({ year: this.dateToday.getFullYear(), month: this.dateToday.getMonth(), day: this.dateToday.getDate() }, [Validators.required]),
    timeOfAppointment: new FormControl({ hour: 16, minute: 0 }, [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
    visible: new FormControl(true, [])
  })

  recommendationForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    street: new FormControl('', [Validators.required]),
    homeNumber: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    phoneNumber: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required]),
    workStatus: new FormControl('', [Validators.required]),
    income: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    agreement: new FormControl('', [Validators.required]),
  })

  offerForm = new FormGroup({
    offerType: new FormControl('', [Validators.required]),
    offerWeb: new FormControl('', [Validators.required]),
    offerNumber: new FormControl('', [Validators.required]),
    programType: new FormControl('', [Validators.required]),
    contactorFirstname: new FormControl('', [Validators.required]),
    contactorLastname: new FormControl('', [Validators.required]),
    contactorJMBG: new FormControl('', [Validators.required]),
    contactorCompanyName: new FormControl('', [Validators.required]),
    contactorTaxID: new FormControl('', [Validators.required]),
    contactorCompanyID: new FormControl('', [Validators.required]),
    contactorEmail: new FormControl('', [Validators.required]),
    contactorPhone: new FormControl('', [Validators.required]),
    insureeFirstname: new FormControl('', [Validators.required]),
    insureeLastname: new FormControl('', [Validators.required]),
    insureeJMBG: new FormControl('', [Validators.required]),
    insuranceStart: new FormControl(null, [Validators.required]),
    period: new FormControl('', [Validators.required]),
    dynamic: new FormControl('', [Validators.required]),
    insuranceSum: new FormControl('', [Validators.required]),
    premiumRate: new FormControl('', [Validators.required]),
    additionalPremiumRate: new FormControl('0', [Validators.required]),
    paymentType: new FormControl('', [Validators.required]),
    clientStatus: new FormControl('', [Validators.required]),
    normalInterestRate: new FormControl('', [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    copy: new FormControl(false, [])
  })

  assignerForm = new FormGroup({
    user: new FormControl('', [Validators.required])
  })

  hideOrShowBool: Boolean = false;
  filterDate = new Date();
  filterForm = new FormGroup({
    dateFrom: new FormControl(null),
    dateTo: new FormControl(null),
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    settlement: new FormControl(''),
    address: new FormControl(''),
    phoneNumber: new FormControl(''),
    statusId: new FormControl(''),
    agentId: new FormControl(''),
    brunchOfficeId: new FormControl(''),
    appointmentType: new FormControl(''),
    statusBool: new FormControl(''),
    agentCode: new FormControl(''),
    agency: new FormControl(''),
    visibility: new FormControl(''),
    contactType: new FormControl('')
  })

  // Forma za Ugovaraca osiguranja
  insuranceContractorForm = new FormGroup({
    responsiblePerson: new FormControl('2', [Validators.required]),
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    responsiblePersonFirstname: new FormControl('', [Validators.required]),
    responsiblePersonLastname: new FormControl('', [Validators.required]),
    legalEntityName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    idLegal: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    pib: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('0[0-9]{7,9}')]),
    addressOfDelivery: new FormControl('', [Validators.required]),
    postalCodeOfDelivery: new FormControl('', [Validators.required]),
    settlementOfDelivery: new FormControl('', [Validators.required]),
    contractorIsInsured: new FormControl(false, []),
    copyToDelivery: new FormControl(false, [])
  })
  // Forma za prvog Osiguranika
  insuredOneForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    dob: new FormControl({ value: '', disabled: true }),
    postalCode: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    job: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('0[0-9]{7,9}')])
  })
  // Forma za drugog Osiguranika
  insuredTwoForm = new FormGroup({
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    address: new FormControl(''),
    dob: new FormControl({ value: '', disabled: true }),
    postalCode: new FormControl(''),
    settlement: new FormControl(''),
    jmbg: new FormControl(''),
    email: new FormControl(''),
    job: new FormControl(''),
    mobile: new FormControl('', [Validators.required, Validators.pattern('0[0-9]{7,9}')]),
    secoundInsuree: new FormControl(false)
  })
  komDomForm: FormGroup = new FormGroup({
    insuranceStart: new FormControl({ value: '', disabled: true }),
    surfaceArea: new FormControl('10', [Validators.required]),
    objectType: new FormControl('0', [Validators.required]),
    builtType: new FormControl({ value: '0', disabled: true }, [Validators.required]),
    insuranceSumStuff: new FormControl('', [Validators.required]),
    paymentFrequency: new FormControl('', [Validators.required]),
    taxRate: new FormControl('5', [Validators.required]),
    paymentType: new FormControl('0', [Validators.required]),
    insureeNumber: new FormControl('L-', [Validators.required, Validators.pattern('^L-[0-9]{6}$')]),
    firstInstalment: new FormControl({ value: '', disabled: true }),
    restOfInstalments: new FormControl({ value: '', disabled: true }),
    premiumTotalWithTaxAndDiscount: new FormControl({ value: '', disabled: true }),
    insuranceSumStuffRSD: new FormControl({ value: '', disabled: true }),
    objectValueEUR: new FormControl({ value: '', disabled: true }),
    objectValueRSD: new FormControl({ value: '', disabled: true })
  })

  constructor(private modalService: NgbModal, private appointmentsService: AppointmentService, private appointmentStatusService: AppointmentStatusService, private userService: UserService, private workStatusSerivce: WorkStatusService, private incomeService: IncomeService, private recommendationService: RecommendationService, private clinetStatusService: ClientStatusService, private offerService: OfferService, private roleSendService: RoleSendService, private branchOfficeService: BranchOfficeService, private nlOfferService: NLOfferService, private nlCalculationService: NLCalculatorService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
  }


  ngOnInit() {
    // console.log(this.filterDate)

    // this.filterDate.setMonth(this.filterDate.getMonth() + 1);
    // this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    // this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })

    this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 11 ? 12 : this.filterDate.getMonth() + 1, day: this.filterDate.getDate() })
    this.filterForm.get('dateTo').setValue({ year: this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 11 ? 12 : this.filterDate.getMonth() + 1, day: this.filterDate.getDate() })

    this.getAll()
    this.getAppointmentStatus();
    this.getUser();
    this.getWorkStatus();
    this.getIncome();
    this.getBoxViewUsers();
    this.getBrunchOffice();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
  }

  getAll() {
    this.filter.data.Filter = { PeriodFrom: this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00", PeriodTo: this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00" };
    if (this.filterForm.value.firstname)
      this.filter.data.Filter.Firstname = this.filterForm.value.firstname
    if (this.filterForm.value.lastname)
      this.filter.data.Filter.Lastname = this.filterForm.value.lastname
    if (this.filterForm.value.address)
      this.filter.data.Filter.Address = this.filterForm.value.address
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.phoneNumber)
      this.filter.data.Filter.PhoneNumber = this.filterForm.value.phoneNumber
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.statusId)
      this.filter.data.Filter.AppointmentStatus = this.filterForm.value.statusId
    if (this.filterForm.value.agentId)
      this.filter.data.Filter.UserID = this.filterForm.value.agentId
    if (this.filterForm.value.brunchOfficeId)
      this.filter.data.Filter.BranchOfficeID = this.filterForm.value.brunchOfficeId
    if (this.filterForm.value.appointmentType)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentType
    if (this.filterForm.value.statusBool == '1')
      this.filter.data.Filter.StatusState = true
    if (this.filterForm.value.statusBool == '0')
      this.filter.data.Filter.StatusState = false
    if (this.filterForm.value.visibility)
      this.filter.data.Filter.Visible = false
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false


    // this.appointmentsArray = this.appointmentsService.gridView(this.filter)
    this.appointmentsService.gridView(this.filter)
      .subscribe(
        (x: any) => {
          console.log(x)
          this.appointmentsArray = x.data;
          this.total = x.total;
        }
      )

  }

  openAddModal(modal) {
    this.addOrEditBool = true;
    this.appointmentsForm.reset({ timeOfAppointment: { hour: 16, minute: 0 }, dateOfAppointment: { year: this.dateToday.getFullYear(), month: this.dateToday.getMonth() + 1, day: this.dateToday.getDate() }, visible: true });
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  addAppointment() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (!mobileRegex.test(this.appointmentsForm.value.mobile)) {
      this.errorTitle = "Nije dobar broj telefona";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      let objapp = {
        Firstname: this.appointmentsForm.value.firstname.toUpperCase(),
        Lastname: this.appointmentsForm.value.lastname.toUpperCase(),
        Street: this.appointmentsForm.value.address.toUpperCase(),
        HomeNumber: this.appointmentsForm.value.homeNumber,
        PostalCode: this.appointmentsForm.value.postalCode,
        Settlement: this.appointmentsForm.value.settlement.toUpperCase(),
        Email: this.appointmentsForm.value.email,
        Mobile: this.appointmentsForm.value.mobile,
        UserID: this.userId
      }
      let appointment = new Appointment({ TimeScheduled: this.appointmentsForm.value.dateOfAppointment.year + '-' + this.appointmentsForm.value.dateOfAppointment.month + '-' + this.appointmentsForm.value.dateOfAppointment.day + ' ' + this.appointmentsForm.value.timeOfAppointment.hour + ':' + this.appointmentsForm.value.timeOfAppointment.minute + ':00', AppointmentSource: this.roleType == 'jivo_adder' ? 2 : 1, AppointmentStatus: parseInt(this.appointmentsForm.value.status), PhonebookID: 0, CallcenterAgent: "", UserID: this.userId, Latitude: 0, Longitude: 0, Comment: this.appointmentsForm.value.comment, Contact: objapp })
      if (this.appointmentsForm.value.visible) {
        appointment.data.Visible = true
      } else {
        appointment.data.Visible = false
      }
      console.log(appointment)
      this.appointmentsService.createAppointment(appointment)
        .then(
          x => {
            console.log(x)
            this.getAll();
            this.modalService.dismissAll()
          }
        )
    }
  }



  openEditAppointmentsModal(modal, id, comment, status) {
    this.addOrEditBool = false;
    this.appointmentId = id;
    console.log(status)
    this.appointmentsForm.get('comment').setValue(comment)
    if (status || status == 0) {
      this.appointmentsForm.get('status').setValue(status.toString())
    } else {
      this.appointmentsForm.get('status').setValue("")
    }
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  editAppointment() {
    this.appointmentsService.editAppointment(this.appointmentId, this.appointmentsForm.value.comment, this.appointmentsForm.value.status)
      .then(
        x => {
          this.getAll()
          this.modalService.dismissAll()
        }
      )
  }

  openRecommendationModal(id) {

  }

  appointmentAddress;
  appointmentSettlement;
  appointmentPostalCode;
  todayDate;
  offerAddBool: boolean = true
  openOfferModal(modal, id, address, settlement, postalCode) {
    this.todayDate = new Date();
    this.appointmentId = id;
    this.appointmentAddress = address;
    this.appointmentSettlement = settlement;
    this.appointmentPostalCode = postalCode;
    this.clientStatuses();
    this.getBoxViewOffers();
    console.log(this.todayDate)
    this.todayDate.setDate(1);
    console.log(this.todayDate.getMonth())
    this.todayDate.setMonth(this.todayDate.getMonth() + 2)
    this.offerForm.reset({ copy: false, insuranceStart: { year: this.todayDate.getFullYear(), month: this.todayDate.getMonth(), day: this.todayDate.getDate() }, additionalPremiumRate: '0' });
    this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
  }
  offerAdd() {
    if (this.offerForm.value.offerType == '0') {
      let offerNumberRegex = new RegExp('^SL[0-9]{10}$')
      if (!offerNumberRegex.test(this.offerForm.value.offerNumber.toUpperCase())) {
        this.errorTitle = "Nije pravilno unet broj ponude. Mora da počinje sa SL i da ima 10 brojnih karaktera";
        this.modalService.open(this.alertModal, { centered: true })
      } else {

        let mobileRegex = new RegExp('0[0-9]{7,9}')
        if (!mobileRegex.test(this.offerForm.value.contactorPhone)) {
          this.errorTitle = "Nije dobar broj telefona";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          this.offerAddBool = false
          console.log(this.offerForm.get('insuranceStart').value)
          let startDate = '';
          let endDate = '';

          startDate = this.offerForm.get('insuranceStart').value.year + '-' + this.offerForm.get('insuranceStart').value.month + '-' + this.offerForm.get('insuranceStart').value.day;

          if (this.offerForm.value.programType != '6') {
            endDate = (this.offerForm.get('insuranceStart').value.year + parseInt(this.offerForm.value.period)).toString() + '-' + this.offerForm.get('insuranceStart').value.month + '-' + this.offerForm.get('insuranceStart').value.day;
          }
          if (this.offerForm.value.programType == '6') {
            endDate = formatDate(new Date(this.offerForm.get('insuranceStart').value.year + Math.ceil(parseInt(this.offerForm.value.period) / 12), this.offerForm.get('insuranceStart').value.month - 1, this.offerForm.get('insuranceStart').value.day), 'yyyy-MM-dd', 'en');
          }

          let dob = '';
          if (this.offerForm.value.programType != '10') {
            if (this.offerForm.value.insureeJMBG.substring(4, 5) == '0') {
              dob = '2' + this.offerForm.value.insureeJMBG.substring(4, 7) + '-' + this.offerForm.value.insureeJMBG.substring(2, 4) + '-' + this.offerForm.value.insureeJMBG.substring(0, 2)
            } else {
              dob = '1' + this.offerForm.value.insureeJMBG.substring(4, 7) + '-' + this.offerForm.value.insureeJMBG.substring(2, 4) + '-' + this.offerForm.value.insureeJMBG.substring(0, 2)
            }
          }

          let offer = new StandardOSOffer({
            OfferType: 0,
            InsuranceStart: startDate,
            InsuranceEnd: endDate,
            OfferNumber: this.offerForm.value.offerNumber.toUpperCase(),
            ProductType: this.offerForm.value.programType,
            PaymentFrequency: this.offerForm.value.dynamic,
            SumInsured: this.offerForm.value.programType != '6' ? this.offerForm.value.insuranceSum : 0,
            CreditAmount: this.offerForm.value.programType == '6' ? this.offerForm.value.insuranceSum : 0,
            PremiumRate: this.offerForm.value.premiumRate,
            AdditionalPremiumRate: this.offerForm.value.additionalPremiumRate,
            PaymentType: this.offerForm.value.paymentType,
            Duration: this.offerForm.value.programType != '6' ? this.offerForm.value.period : 0,
            PaymentPeriodMonths: this.offerForm.value.programType == '6' ? this.offerForm.value.period : 0,
            PaymentPeriod: this.offerForm.value.programType == '6' ? Math.round(Math.round(this.offerForm.value.period / 12) * 0.8) : 0,
            ClientStatusID: this.offerForm.value.clientStatus,
            Comment: this.offerForm.value.comment,
            UserID: this.userId,
            ContractorIsInsuree: this.offerForm.value.copy,
            Interest: this.offerForm.value.programType == '6' ? this.offerForm.value.normalInterestRate / 100 : 0,
            Contractor: new OfferClient('0', this.offerForm.value.programType != '10' ? this.offerForm.value.contactorFirstname.toUpperCase() : '', this.offerForm.value.programType != '10' ? this.offerForm.value.contactorLastname.toUpperCase() : '', this.offerForm.value.programType == '10' ? this.offerForm.value.contactorCompanyName.toUpperCase() : '', this.offerForm.value.programType != '10' ? this.offerForm.value.contactorJMBG : '00000' + this.offerForm.value.contactorCompanyID.toString(),
              this.offerForm.value.contactorPhone, this.offerForm.value.contactorEmail, this.appointmentAddress, this.appointmentSettlement, this.appointmentPostalCode, this.appointmentAddress, this.appointmentSettlement, '', 0, this.offerForm.value.programType == '10' ? this.offerForm.value.contactorTaxID.toUpperCase() : '', this.offerForm.value.programType == '10' ? this.offerForm.value.contactorCompanyID.toUpperCase() : ''),
            Insuree: new OfferInsuree(this.offerForm.value.programType != '10' ? this.offerForm.value.insureeFirstname.toUpperCase() : 'Lista korisnika', this.offerForm.value.programType != '10' ? this.offerForm.value.insureeLastname.toUpperCase() : '', this.offerForm.value.programType != '10' ? this.offerForm.value.insureeJMBG : '9999999999999', this.offerForm.value.programType != '10' ? dob : '')
          })
          console.log(offer);
          this.offerService.createDigitalOffer(offer)
            .then(
              x => {
                console.log(x)
                this.appointmentsService.connetToOffer(this.appointmentId, this.offerForm.value.offerNumber)
                  .then(
                    x => {
                      this.offerAddBool = true
                      console.log(x);
                      this.offerForm.reset();
                      this.getAll();
                    }
                  )
              },
              (x: { error: String }) => {
                console.log(x)
                this.offerAddBool = true
                this.errorTitle = x.error;
                this.modalService.open(this.alertModal, { centered: true })
              }
            )

        }
      }
    } else {
      this.offerAddBool = false
      this.appointmentsService.connetToOffer(this.appointmentId, this.offerForm.value.offerWeb)
        .then(
          x => {
            console.log(x);
            this.offerAddBool = true
            this.offerForm.reset();
            this.getAll();
          }
        )
    }
  }

  openContactModal(modal, id) {
    this.appointmentId = id;
    this.recommendationForm.reset();
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  addRecommendation() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (!mobileRegex.test(this.recommendationForm.value.mobile)) {
      this.errorTitle = "Nije dobar broj mobilnog telefona";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      let recommendation = new Recommendation({
        Firstname: this.recommendationForm.value.firstname.toUpperCase(),
        Lastname: this.recommendationForm.value.lastname.toUpperCase(),
        Street: this.recommendationForm.value.street.toUpperCase(),
        HomeNumber: this.recommendationForm.value.homeNumber,
        Settlement: this.recommendationForm.value.settlement.toUpperCase(),
        PostalCode: this.recommendationForm.value.postalCode,
        Email: this.recommendationForm.value.email,
        PhoneNumber: this.recommendationForm.value.phoneNumber,
        Mobile: this.recommendationForm.value.mobile,
        WorkStatusID: parseInt(this.recommendationForm.value.workStatus),
        IncomeID: parseInt(this.recommendationForm.value.income),
        UserID: this.userId,
        Remark: this.recommendationForm.value.remark,
        PersonalAgreement: "",
        AppointmentID: this.appointmentId
      })
      console.log(recommendation);
      this.recommendationService.createContact(recommendation)
        .then(
          x => {
            console.log(x);
            this.getAll();
            this.modalService.dismissAll();
          }
        )
    }
  }

  boxAppointmentArray: Observable<any>;
  getBoxViewUsers() {
    let fil = new Filter({ Top: null, Page: null, Filter: {}, Sort: { SortBy: 'Active', Direction: 1 } })
    if (this.filterForm.value.brunchOfficeId)
      fil.data.Filter.BranchOfficeID = this.filterForm.value.brunchOfficeId
    this.boxAppointmentArray = this.userService.boxView(fil)
  }
  openChangeAssignerModal(modal, id) {
    this.appointmentId = id;
    this.assignerForm.reset();
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  changeAssignerApp() {
    this.appointmentsService.changeAssigner(this.appointmentId, this.assignerForm.value.user)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openChangeVisibilitiModal(modal, id, status) {
    this.appointmentId = id;
    this.appointmentStatus = !status;
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  changeAppStatus() {
    this.appointmentsService.changeStatus(this.appointmentId, this.appointmentStatus)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openGoogleMaps() {
    // window.open("https://www.google.com/maps/search/?api=1&query=", "_blank")
    window.open("https://www.google.com/maps", "_blank")
  }

  getAppointmentStatus() {
    this.appointmentStatusArray = this.appointmentStatusService.gridView()
  }

  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number }) => {
          this.userId = x.id;
        }
      )
  }

  exportAppointmet() {
    this.filter.data.Filter = { PeriodFrom: this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00", PeriodTo: this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00" };
    if (this.filterForm.value.firstname)
      this.filter.data.Filter.Firstname = this.filterForm.value.firstname
    if (this.filterForm.value.lastname)
      this.filter.data.Filter.Lastname = this.filterForm.value.lastname
    if (this.filterForm.value.address)
      this.filter.data.Filter.Address = this.filterForm.value.address
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.phoneNumber)
      this.filter.data.Filter.PhoneNumber = this.filterForm.value.phoneNumber
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.statusId)
      this.filter.data.Filter.AppointmentStatus = this.filterForm.value.statusId
    if (this.filterForm.value.agentId)
      this.filter.data.Filter.UserID = this.filterForm.value.agentId
    if (this.filterForm.value.brunchOfficeId)
      this.filter.data.Filter.BranchOfficeID = this.filterForm.value.brunchOfficeId
    if (this.filterForm.value.appointmentType)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentType
    if (this.filterForm.value.statusBool == '1')
      this.filter.data.Filter.StatusState = true
    if (this.filterForm.value.statusBool == '0')
      this.filter.data.Filter.StatusState = false
    if (this.filterForm.value.visibility)
      this.filter.data.Filter.Visible = false
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false

    this.appointmentsService.appointmentsExcel(this.filter)
      .subscribe(
        (x: any) => {
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  copyCont() {
    if (this.offerForm.value.copy) {
      this.offerForm.get('insureeFirstname').setValue(this.offerForm.value.contactorFirstname);
      this.offerForm.get('insureeLastname').setValue(this.offerForm.value.contactorLastname);
      this.offerForm.get('insureeJMBG').setValue(this.offerForm.value.contactorJMBG);
    } else {
      this.offerForm.get('insureeFirstname').setValue('');
      this.offerForm.get('insureeLastname').setValue('');
      this.offerForm.get('insureeJMBG').setValue('');
    }
  }
  copyIfTrue() {
    if (this.offerForm.value.copy) {
      this.offerForm.get('insureeFirstname').setValue(this.offerForm.value.contactorFirstname);
      this.offerForm.get('insureeLastname').setValue(this.offerForm.value.contactorLastname);
      this.offerForm.get('insureeJMBG').setValue(this.offerForm.value.contactorJMBG);
    }
  }

  get validInsuranceContractorForm() {
    return this.insuranceContractorForm.controls;
  }
  validDigital: Boolean = false;
  changeTypeOfPerson(eve) {
    this.validDigital = false;
    if (eve.target.value == '1') {
      this.insuredOneForm.reset()
      this.insuranceContractorForm.get('contractorIsInsured').setValue(false)
    }
  }
  contractorBool: boolean = false
  insuredOneBool: boolean = false
  insuredTwoBool: boolean = false
  hideContracotr() {
    this.contractorBool = !this.contractorBool;
  }
  insuredOneHide() {
    this.insuredOneBool = !this.insuredOneBool;
  }
  insuredTwoHide() {
    this.insuredTwoBool = !this.insuredTwoBool;
  }
  komdomCalculatorBool: boolean = true
  komdomCalculatorHide() {
    this.komdomCalculatorBool = !this.komdomCalculatorBool
  }
  copyDelivery() {
    if (this.insuranceContractorForm.value.copyToDelivery) {
      this.insuranceContractorForm.get('addressOfDelivery').setValue(this.insuranceContractorForm.value.address)
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue(this.insuranceContractorForm.value.postalCode)
      this.insuranceContractorForm.get('settlementOfDelivery').setValue(this.insuranceContractorForm.value.settlement)
    } else {
      this.insuranceContractorForm.get('addressOfDelivery').setValue('')
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue('')
      this.insuranceContractorForm.get('settlementOfDelivery').setValue('')
    }
  }
  changeCopyForm() {
    this.insuredOneBool = true;
    if (this.insuranceContractorForm.value.contractorIsInsured) {
      if (this.insuranceContractorForm.value.contractorIsInsured) {
        this.insuredOneForm.reset({ firstname: this.insuranceContractorForm.value.firstname, lastname: this.insuranceContractorForm.value.lastname, address: this.insuranceContractorForm.value.address, postalCode: this.insuranceContractorForm.value.postalCode, settlement: this.insuranceContractorForm.value.settlement, jmbg: this.insuranceContractorForm.value.jmbg, email: this.insuranceContractorForm.value.email, phonenumber: this.insuranceContractorForm.value.phonenumber, mobile: this.insuranceContractorForm.value.mobile, job: this.insuredOneForm.value.job })
        if (this.insuranceContractorForm.value.jmbg) {
          if (this.insuredOneForm.value.jmbg.length >= 7) {
            if (this.insuredOneForm.value.jmbg.substring(4, 5) == '0') {
              this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.2' + this.insuredOneForm.value.jmbg.substring(4, 7))
            } else {
              this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.1' + this.insuredOneForm.value.jmbg.substring(4, 7))
            }
          } else {
            this.insuredOneForm.get('dob').setValue('')
          }
        }
      }
    } else {
      this.insuredOneForm.reset({ job: this.insuredOneForm.value.job });
    }
  }
  copyToInsured() {
    if (this.insuranceContractorForm.value.copyToDelivery) {
      this.insuranceContractorForm.get('addressOfDelivery').setValue(this.insuranceContractorForm.value.address)
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue(this.insuranceContractorForm.value.postalCode)
      this.insuranceContractorForm.get('settlementOfDelivery').setValue(this.insuranceContractorForm.value.settlement)
    }
    if (this.insuranceContractorForm.value.contractorIsInsured) {
      this.insuredOneForm.get('firstname').setValue(this.insuranceContractorForm.value.firstname);
      this.insuredOneForm.get('lastname').setValue(this.insuranceContractorForm.value.lastname);
      this.insuredOneForm.get('jmbg').setValue(this.insuranceContractorForm.value.jmbg);
      this.insuredOneForm.get('address').setValue(this.insuranceContractorForm.value.address);
      this.insuredOneForm.get('postalCode').setValue(this.insuranceContractorForm.value.postalCode);
      this.insuredOneForm.get('settlement').setValue(this.insuranceContractorForm.value.settlement);
      this.insuredOneForm.get('email').setValue(this.insuranceContractorForm.value.email);
      this.insuredOneForm.get('mobile').setValue(this.insuranceContractorForm.value.mobile);
      if (this.insuranceContractorForm.value.jmbg) {
        if (this.insuredOneForm.value.jmbg.length >= 7) {
          if (this.insuredOneForm.value.jmbg.substring(4, 5) == '0') {
            this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.2' + this.insuredOneForm.value.jmbg.substring(4, 7))
          } else {
            this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.1' + this.insuredOneForm.value.jmbg.substring(4, 7))
          }
        } else {
          this.insuredOneForm.get('dob').setValue('')
        }
      }
    }
  }
  komDomTodayDate = new Date()
  komDomDate = new Date()
  plusDate: boolean = false
  minusDate: boolean = true
  openKomDomModal(modal: any, id: number) {
    this.validCalculate = false
    this.insuranceContractorForm.reset({ responsiblePerson: '2', firstname: '', lastname: '', responsiblePersonFirstname: '', responsiblePersonLastname: '', legalEntityName: '', jmbg: '', idLegal: '', email: '', address: '', pib: '', settlement: '', postalCode: '', mobile: '', addressOfDelivery: '', postalCodeOfDelivery: '', settlementOfDelivery: '', contractorIsInsured: false, copyToDelivery: false })
    this.insuredOneForm.reset({ firstname: '', lastname: '', address: '', dob: '', postalCode: '', settlement: '', jmbg: '', email: '', job: '', mobile: '' })
    this.insuredTwoForm.reset({ firstname: '', lastname: '', address: '', dob: '', postalCode: '', settlement: '', jmbg: '', email: '', job: '', mobile: '' })
    this.komDomForm.reset({ insuranceStart: '', surfaceArea: '10', objectType: '0', builtType: '0', insuranceSumStuff: '', paymentFrequency: '', taxRate: '5', paymentType: '0', insureeNumber: 'L-', firstInstalment: '', restOfInstalments: '', premiumTotalWithTaxAndDiscount: '', insuranceSumStuffRSD: '' })
    this.komDomForm.controls['builtType'].disable()
    this.calculateBool = false
    this.plusDate = false
    this.minusDate = true
    this.komDomDate = new Date()
    this.komDomForm.get('insuranceStart').setValue(formatDate(this.komDomDate, 'dd.MM.yyyy', 'en'))
    this.appointmentId = id
    this.getExcangeRate(this.komDomForm.get('insuranceStart').value)
    this.modalService.open(modal, { backdrop: 'static', size: 'xl' })
  }
  setFirstInsureeDOB() {
    if (this.insuredOneForm.value.jmbg) {
      if (this.insuredOneForm.value.jmbg.length >= 7) {
        if (this.insuredOneForm.value.jmbg.substring(4, 5) == '0') {
          this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.2' + this.insuredOneForm.value.jmbg.substring(4, 7))
        } else {
          this.insuredOneForm.get('dob').setValue(this.insuredOneForm.value.jmbg.substring(0, 2) + "." + this.insuredOneForm.value.jmbg.substring(2, 4) + '.1' + this.insuredOneForm.value.jmbg.substring(4, 7))
        }
      } else {
        this.insuredOneForm.get('dob').setValue('')
      }
    }
  }
  setSecondInsureeDOB() {
    if (this.insuredTwoForm.value.jmbg) {
      if (this.insuredTwoForm.value.jmbg.length >= 7) {
        if (this.insuredTwoForm.value.jmbg.substring(4, 5) == '0') {
          this.insuredTwoForm.get('dob').setValue(this.insuredTwoForm.value.jmbg.substring(0, 2) + "." + this.insuredTwoForm.value.jmbg.substring(2, 4) + '.2' + this.insuredTwoForm.value.jmbg.substring(4, 7))
        } else {
          this.insuredTwoForm.get('dob').setValue(this.insuredTwoForm.value.jmbg.substring(0, 2) + "." + this.insuredTwoForm.value.jmbg.substring(2, 4) + '.1' + this.insuredTwoForm.value.jmbg.substring(4, 7))
        }
      } else {
        this.insuredTwoForm.get('dob').setValue('')
      }
    }
  }
  clearCalculation = () => {
    this.calculateBool = false
    this.komDomForm.get('firstInstalment').setValue('')
    this.komDomForm.get('insuranceSumStuffRSD').setValue('')
    this.komDomForm.get('restOfInstalments').setValue('')
    this.komDomForm.get('premiumTotalWithTaxAndDiscount').setValue('')
    this.komDomForm.get('objectValueEUR').setValue('')
    this.komDomForm.get('objectValueRSD').setValue('')
  }
  changeDate(bool: boolean) {
    this.komDomTodayDate = new Date()
    this.komDomTodayDate.setHours(0, 0, 0)
    this.komDomDate.setHours(0, 0, 0)
    if (bool && this.komDomDate.getDate() != this.komDomTodayDate.getDate()) {
      this.komDomDate.setDate(this.komDomDate.getDate() + 1)
      if (this.komDomDate.getDate() == this.komDomTodayDate.getDate()) {
        this.plusDate = false
        this.minusDate = true
      } else {
        this.plusDate = true
        this.minusDate = true
      }
    }
    this.komDomTodayDate.setDate(this.komDomTodayDate.getDate() - 3)
    if (!bool && this.komDomDate.getDate() != this.komDomTodayDate.getDate()) {
      this.komDomDate.setDate(this.komDomDate.getDate() - 1)
      if (this.komDomDate.getDate() == this.komDomTodayDate.getDate()) {
        this.plusDate = true
        this.minusDate = false
      } else {
        this.plusDate = true
        this.minusDate = true
      }
    }
    this.komDomForm.get('insuranceStart').setValue(formatDate(this.komDomDate, 'dd.MM.yyyy', 'en'))
    this.getExcangeRate(this.komDomForm.get('insuranceStart').value)
  }
  komDomCreate() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    let offerNumberRegex = new RegExp('^L-[0-9]{6}$')
    if (
      (this.insuranceContractorForm.value.responsiblePerson == '1' && (!this.insuranceContractorForm.value.responsiblePersonFirstname || !this.insuranceContractorForm.value.responsiblePersonLastname || !this.insuranceContractorForm.value.pib || !this.insuranceContractorForm.value.idLegal || !this.insuranceContractorForm.value.legalEntityName || this.insuranceContractorForm.value.pib.length != 9 || this.insuranceContractorForm.value.idLegal.length != 8)) ||
      (this.insuranceContractorForm.value.responsiblePerson == '2' && (!this.insuranceContractorForm.value.firstname || !this.insuranceContractorForm.value.lastname)) ||
      !this.insuranceContractorForm.value.jmbg ||
      this.insuranceContractorForm.value.jmbg.length != 13 ||
      !this.insuranceContractorForm.value.mobile ||
      !mobileRegex.test(this.insuranceContractorForm.value.mobile) ||
      !this.insuranceContractorForm.value.email ||
      !this.insuranceContractorForm.value.address ||
      !this.insuranceContractorForm.value.settlement ||
      !this.insuranceContractorForm.value.postalCode ||
      !this.insuranceContractorForm.value.addressOfDelivery ||
      !this.insuranceContractorForm.value.settlementOfDelivery ||
      !this.insuranceContractorForm.value.postalCodeOfDelivery
    ) {
      this.validDigital = true
      this.contractorBool = true
      this.errorTitle = 'Nisu svi podaci pravilno popunjeni'
      this.modalService.open(this.alertModal, { centered: true })
      console.log('Nisu popunjeni podaci o ugovaracu')
    } else {
      console.log('Popunjeni podaci o ugovaracu')
      if (
        !this.insuredOneForm.value.firstname ||
        !this.insuredOneForm.value.lastname ||
        !this.insuredOneForm.value.jmbg ||
        !this.insuredOneForm.get('dob').value ||
        !this.insuredOneForm.value.email ||
        !this.insuredOneForm.value.mobile ||
        !mobileRegex.test(this.insuredOneForm.value.mobile) ||
        !this.insuredOneForm.value.address ||
        !this.insuredOneForm.value.postalCode ||
        !this.insuredOneForm.value.settlement
      ) {
        this.validDigital = true
        this.insuredOneBool = true
        this.errorTitle = 'Nisu svi podaci pravilno popunjeni'
        this.modalService.open(this.alertModal, { centered: true })
        console.log('Nisu popunjeni podaci o prvom osiguraniku')
      } else {
        console.log('Popunjeni podaci o prvom osiguraniku')
        if (
          !offerNumberRegex.test(this.komDomForm.value.insureeNumber) ||
          !this.komDomForm.value.insureeNumber ||
          !this.komDomForm.value.objectType ||
          !this.komDomForm.value.surfaceArea ||
          !this.komDomForm.get('builtType').value ||
          !this.komDomForm.value.paymentFrequency ||
          !this.komDomForm.value.insuranceSumStuff ||
          !this.komDomForm.value.paymentType
        ) {
          this.validDigital = true
          this.insuredTwoBool = true
          this.errorTitle = 'Nisu svi podaci pravilno popunjeni'
          this.modalService.open(this.alertModal, { centered: true })
          console.log('Kalkulacija nije popunjena')
        } else {
          if (!this.calculateBool) {
            this.errorTitle = 'Nije odradjena kalkulacija'
            this.modalService.open(this.alertModal, { centered: true })
          } else {

            let komdom: NLOffer = {
              OfferType: 0,
              ProductType: 0,
              IdentificationType: 0,
              IdentificationFinished: true,
              OfferStatus: 2,
              InsuranceStart: this.komDomForm.get('insuranceStart').value.split('.')[2] + '-' + this.komDomForm.get('insuranceStart').value.split('.')[1] + '-' + this.komDomForm.get('insuranceStart').value.split('.')[0],
              OfferNumber: this.komDomForm.value.insureeNumber,
              ContractorID: 0,
              Insuree1ID: 0,
              SurfaceArea: this.komDomForm.value.surfaceArea,
              ObjectType: this.komDomForm.value.objectType,
              ConversionRateEUR: this.currencyMid,
              BuiltType: this.komDomForm.get('builtType').value,
              Duration: 1,
              CoverPeriod: 1,
              OneTimePayment: false,
              PaymentFrequency: this.komDomForm.value.paymentFrequency,
              TaxRate: 0.05,

              UnitValue: 0,
              ObjectValueEUR: 0,
              ObjectValueRSD: 0,
              PremiumRatePerBuiltType: 0,
              PremiumRateObjectRSD: 0,
              InsuranceSumStuffEUR: Number(this.komDomForm.value.insuranceSumStuff),
              InsuranceSumStuffRSD: 0,
              PremiumRateStuffEUR: 0,
              PremiumRateStuffRSD: 0,
              PremiumTotal: 0,
              Discount: 0,
              PremiumTotalWithTaxAndDiscount: 0,
              FirstInstalment: 0,
              RestOfInstalments: 0,
              InsuranceSumTotalEUR: 0,

              PaymentDiscount: 0,
              PaymentType: Number(this.komDomForm.value.paymentType),
              NotificationsAgreement: true,
              Verified1: true,
              Verified2: true,
              Verified3: true,
              AppointmentID: Number(this.appointmentId),
              UserID: this.userId,
              Contractor: {
                ClientType: this.insuranceContractorForm.value.responsiblePerson,
                Firstname: this.insuranceContractorForm.value.responsiblePerson == '1' ? this.insuranceContractorForm.value.responsiblePersonFirstname.toUpperCase() : this.insuranceContractorForm.value.firstname.toUpperCase(),
                Lastname: this.insuranceContractorForm.value.responsiblePerson == '1' ? this.insuranceContractorForm.value.responsiblePersonLastname.toUpperCase() : this.insuranceContractorForm.value.lastname.toUpperCase(),
                CompanyName: this.insuranceContractorForm.value.responsiblePerson == '1' ? this.insuranceContractorForm.value.legalEntityName.toUpperCase() : '',
                JMBG: this.insuranceContractorForm.value.jmbg,
                Mobile: this.insuranceContractorForm.value.mobile,
                Email: this.insuranceContractorForm.value.email,
                Address: this.insuranceContractorForm.value.address.toUpperCase(),
                Settlement: this.insuranceContractorForm.value.settlement.toUpperCase(),
                PostalCode: this.insuranceContractorForm.value.postalCode,
                DeliveryAddress: this.insuranceContractorForm.value.addressOfDelivery.toUpperCase(),
                DeliverySettlement: this.insuranceContractorForm.value.settlementOfDelivery.toUpperCase(),
                DeliveryPostalCode: this.insuranceContractorForm.value.postalCodeOfDelivery,
                TaxID: this.insuranceContractorForm.value.responsiblePerson == '1' ? this.insuranceContractorForm.value.pib : '',
                CompanyID: this.insuranceContractorForm.value.responsiblePerson == '1' ? this.insuranceContractorForm.value.idLegal : '',
              },
              Insuree1: {
                Firstname: this.insuredOneForm.value.firstname.toUpperCase(),
                Lastname: this.insuredOneForm.value.lastname.toUpperCase(),
                JMBG: this.insuredOneForm.value.jmbg,
                DOB: this.insuredOneForm.value.dob,
                Email: this.insuredOneForm.value.email,
                Mobile: this.insuredOneForm.value.mobile,
                Address: this.insuredOneForm.value.address.toUpperCase(),
                Settlement: this.insuredOneForm.value.settlement.toUpperCase(),
                PostalCode: this.insuredOneForm.value.postalCode,
                Occupation: this.insuredOneForm.value.job.toUpperCase()
              },
              Insuree2: !this.insuredTwoForm.value.secoundInsuree ? null : {
                Firstname: this.insuredTwoForm.value.firstname.toUpperCase(),
                Lastname: this.insuredTwoForm.value.lastname.toUpperCase(),
                JMBG: this.insuredTwoForm.value.jmbg,
                DOB: this.insuredTwoForm.value.dob,
                Email: this.insuredTwoForm.value.email,
                Mobile: this.insuredTwoForm.value.mobile,
                Address: this.insuredTwoForm.value.address.toUpperCase(),
                Settlement: this.insuredTwoForm.value.settlement.toUpperCase(),
                PostalCode: this.insuredTwoForm.value.postalCode,
                Occupation: this.insuredTwoForm.value.job.toUpperCase()
              }
            }

            this.nlCalculationService.komDomCalculation({
              BuiltType: Number(this.komDomForm.get('builtType').value),
              ConversionRateEUR: this.currencyMid,
              Duration: 1,
              InsuranceSumStuff: Number(this.komDomForm.value.insuranceSumStuff),
              ObjectType: Number(this.komDomForm.value.objectType),
              PaymentFrequency: Number(this.komDomForm.value.paymentFrequency),
              SurfaceArea: this.komDomForm.value.surfaceArea,
              TaxRate: 0.05
            })
              .then(
                (x: any) => {
                  console.log(x)
                  komdom.UnitValue = x.unitValue
                  komdom.ObjectValueEUR = x.objectValueEUR
                  komdom.ObjectValueRSD = x.objectValueRSD
                  komdom.PremiumRatePerBuiltType = x.premiumRatePerBuiltType
                  komdom.PremiumRateObjectRSD = x.premiumRateObjectRSD
                  komdom.InsuranceSumStuffRSD = x.insuranceSumStuffRSD
                  komdom.PremiumRateStuffEUR = x.premiumRateStuffEUR
                  komdom.PremiumRateStuffRSD = x.premiumRateStuffRSD
                  komdom.PremiumTotal = x.premiumTotal
                  komdom.Discount = x.discount
                  komdom.PremiumTotalWithTaxAndDiscount = x.premiumTotalWithTaxAndDiscount
                  komdom.FirstInstalment = x.firstInstalment
                  komdom.RestOfInstalments = x.restOfInstalments
                  komdom.InsuranceSumTotalEUR = x.insuranceSumTotalEUR
                }
              )
              .catch(
                e => {
                  console.log(e)
                  this.errorTitle = e.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
              .finally(
                () => {
                  console.log(komdom)

                  this.nlOfferService.createOffer(komdom)
                    .then(
                      x => {
                        console.log(x)
                        this.modalService.dismissAll()
                        this.getAll()
                      }
                    )
                    .catch(
                      e => {
                        console.log(e)
                        this.errorTitle = e.error;
                        this.modalService.open(this.alertModal, { centered: true })
                      }
                    )
                }
              )
          }
        }
      }
    }
  }
  currencyMid: number = 0
  calculateBool: boolean = false
  validCalculate: boolean = false
  calculationObj: any
  komDomCalculate = () => {
    if (!this.komDomForm.get('builtType').value || !this.komDomForm.value.insuranceSumStuff || !this.komDomForm.value.objectType || !this.komDomForm.value.paymentFrequency || !this.komDomForm.value.surfaceArea) {
      this.validCalculate = true
      this.errorTitle = 'Niste uneli sve podatke za kalkulaciju';
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      this.validCalculate = false
      this.komDomForm.get('firstInstalment').setValue(0)
      this.komDomForm.get('insuranceSumStuffRSD').setValue(0)
      this.komDomForm.get('restOfInstalments').setValue(0)
      this.komDomForm.get('premiumTotalWithTaxAndDiscount').setValue(0)
      this.nlCalculationService.komDomCalculation({
        BuiltType: Number(this.komDomForm.get('builtType').value),
        ConversionRateEUR: this.currencyMid,
        Duration: 1,
        InsuranceSumStuff: Number(this.komDomForm.value.insuranceSumStuff),
        ObjectType: Number(this.komDomForm.value.objectType),
        PaymentFrequency: Number(this.komDomForm.value.paymentFrequency),
        SurfaceArea: this.komDomForm.value.surfaceArea,
        TaxRate: 0.05
      })
        .then(
          (x: any) => {
            console.log(x)
            this.calculationObj = x
            this.calculateBool = true
            this.komDomForm.get('firstInstalment').setValue(x.firstInstalment)
            this.komDomForm.get('insuranceSumStuffRSD').setValue(x.insuranceSumStuffRSD)
            this.komDomForm.get('restOfInstalments').setValue(x.restOfInstalments)
            this.komDomForm.get('premiumTotalWithTaxAndDiscount').setValue(x.premiumTotalWithTaxAndDiscount)
            this.komDomForm.get('objectValueEUR').setValue(x.objectValueEUR)
            this.komDomForm.get('objectValueRSD').setValue(x.objectValueRSD)
          }
        )
        .catch(
          e => {
            console.log(e)
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    }
  }
  sumStuffArr: Array<number> = []
  setValues = (inputType: string) => {
    this.clearCalculation()
    if (this.komDomForm.value.objectType && this.komDomForm.value.surfaceArea) {
      this.nlCalculationService.komDomValues(Number(this.komDomForm.value.objectType), this.komDomForm.value.surfaceArea)
        .then(
          (x: { insuredSumList: Array<number> }) => {
            // console.log(x)
            this.sumStuffArr = x.insuredSumList
            this.komDomForm.get('insuranceSumStuff').setValue(x.insuredSumList[0])
          }
        )
        .catch(
          e => console.log(e)
        )
    }
    if (inputType == 'type' && this.komDomForm.value.objectType == '0') {
      this.komDomForm.get('builtType').setValue('0')
      this.komDomForm.controls['builtType'].disable()
    } else if (inputType == 'type' && this.komDomForm.value.objectType != '0') {
      this.komDomForm.controls['builtType'].enable()
    }

  }
  getExcangeRate = (date: string) => {
    this.nlCalculationService.getExchangeRate(date)
      .then(
        x => {
          // console.log(x)
          this.currencyMid = Number(x.result.eur.sre)
        }
      )
      .catch(
        e => console.log(e)
      )
      .finally(
        () => this.setValues('')
      )
  }



  getWorkStatus() {
    this.workStatusArray = this.workStatusSerivce.gridView()
  }
  getIncome() {
    this.incomeArray = this.incomeService.gridView();
  }
  clientStatus: Observable<Lookup>;
  clientStatuses() {
    this.clientStatus = this.clinetStatusService.gridView();
  }

  boxViewOffers;
  getBoxViewOffers() {
    this.boxViewOffers = this.offerService.boxView(new Filter({ Top: null, Page: null, Filter: { HasAppointment: false, OfferType: 1, OfferStatuses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11] }, Sort: {} }))
  }

  brunchOffices: Observable<Lookup[]>;
  getBrunchOffice() {
    this.brunchOffices = this.branchOfficeService.boxView();
  }

  hideOrShow() {
    this.hideOrShowBool = !this.hideOrShowBool;
  }

  clearFilters() {
    this.filterForm.reset({ dateFrom: { year: this.filterForm.value.dateFrom.year, month: this.filterForm.value.dateFrom.month, day: this.filterForm.value.dateFrom.day }, dateTo: { year: this.filterForm.value.dateTo.year, month: this.filterForm.value.dateTo.month, day: this.filterForm.value.dateTo.day }, firstname: '', lastname: '', settlement: '', address: '', phoneNumber: '', statusId: '', agentId: '', brunchOfficeId: '', appointmentType: '', statusBool: '', agentCode: '', visibility: '', contactType: '' })
    this.getAll();
  }
  legenBool: Boolean = false;
  openLegend() {
    this.legenBool = !this.legenBool;
  }

}
